import {combineReducers} from 'redux';
import user from './authenticationReducer';
import briefs from './briefsReducer';

const appReducer = combineReducers({
  user,
  briefs,
});

const rootReducer = (state, action) => {
  if(action.type === 'LOGOUT_USER_SUCCESS') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
